import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/booking_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  reference_cont: {
    model_name: 'Booking',
    column_type: 'string',
    column_name: 'reference',
  },
  status_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Booking',
      options: ['provisional', 'wait_to_pay', 'wait_to_add_payment', 'ready_to_be_confirmed', 'confirmed', 'in_aftersales', 'cancelled', 'rebooking', 'closed'],
    },
    model_name: 'Booking',
    column_name: 'status',
  },
  user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'Booking',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'Booking',
  },
  created_at_gteq: {
    column_type: 'datetime',
    model_name: 'Booking',
    column_name: 'createdAt',
  },
  created_at_lteq: {
    column_type: 'datetime',
    model_name: 'Booking',
    column_name: 'createdAt',
  },
  id_in: {
    model_name: 'Booking',
    column_type: 'string',
    column_name: 'id',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Booking', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Booking', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
